import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import { NotificacaoModel } from '@app/data/notificacao/models';
import { NotificacaoRepository } from '@app/data/notificacao/notificacao.repository';

@Injectable()
export class NotificacaoController extends BaseController<NotificacaoModel> {
  constructor(notificacaoRepository: NotificacaoRepository) {
    super(notificacaoRepository);
  }
}
